
export const CaseActions = Object.freeze({
    "Create": 1,
    "Update": 2,
    "StateUpdate": 3,
    "TaxonomyUpdate": 4,
    "ScheduleDateUpdate": 5,
    "ScaleDateUpdate": 6,
    "CreateDocumentation": 7,
    "SendSMS": 8,
    "EmailOutbound": 9,
    "EmailInbound": 10,
})
